export default {
	"baiduPointMap": {
		"handleTips": "Please drag the coordinate address"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/components/map/map.js